<h2 mat-dialog-title>Daten werden geladen</h2>
<div mat-dialog-content>
  <mat-spinner style="margin: 0 auto;"></mat-spinner>
</div>
